import React, { useLayoutEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import theme from "theme";

export const PAGE_OPTIONS = [
	{ value: "portfolio", label: "👨‍💻 Tech + Design" },
	{ value: "about", label: "👋 Customer Experience" },
];

const Track = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	background-color: white;
	border-radius: 100px;
	padding: 6px;
	gap: 6px;
	box-shadow: 0 0 20px rgba(0, 0, 0, 1);
	margin-bottom: 30px;
`;

const SlidingPill = styled.div`
	position: absolute;
	top: 6px;
	bottom: 6px;
	left: ${(props) => props.$left}px;
	width: ${(props) => props.$width}px;
	border-radius: 100px;
	background-color: #2b2b2b;
	transition: ${(props) =>
		props.$ready
			? "left 0.28s cubic-bezier(0.22, 1, 0.36, 1), width 0.28s cubic-bezier(0.22, 1, 0.36, 1)"
			: "none"};
	pointer-events: none;
	z-index: 0;
	opacity: ${(props) => (props.$ready ? 1 : 0)};
`;

const OptionButton = styled.button`
	position: relative;
	z-index: 1;
	appearance: none;
	border: none;
	background: transparent;
	cursor: pointer;
	text-transform: none;
	font-family: ${theme.typography.fontFamily};
	font-weight: bold;
	font-size: 18px;
	color: ${(props) => (props.$active ? "#ffffff" : theme.palette.neutral.main)};
	padding: 12px 28px;
	min-width: 140px;
	border-radius: 100px;
	transition: color 0.2s ease, background-color 0.2s ease;

	&:hover {
		color: ${(props) => (props.$active ? "#ffffff" : "#2b2b2b")};
		background-color: rgba(0, 0, 0, 0.1);
	}
`;

const PageSelector = ({ value, onChange, options = PAGE_OPTIONS }) => {
	const buttonRefs = useRef({});
	const [pill, setPill] = useState({ left: 0, width: 0, ready: false });

	const updatePill = () => {
		const activeButton = buttonRefs.current[value];
		if (!activeButton) return;

		setPill({
			left: activeButton.offsetLeft,
			width: activeButton.offsetWidth,
			ready: true,
		});
	};

	useLayoutEffect(() => {
		updatePill();
	}, [value, options]);

	useLayoutEffect(() => {
		window.addEventListener("resize", updatePill);
		return () => window.removeEventListener("resize", updatePill);
	}, [value]);

	return (
		<Track>
			<SlidingPill $left={pill.left} $width={pill.width} $ready={pill.ready} />
			{options.map((option) => (
				<OptionButton
					key={option.value}
					type='button'
					ref={(node) => {
						buttonRefs.current[option.value] = node;
					}}
					aria-pressed={value === option.value}
					$active={value === option.value}
					onClick={() => onChange(option.value)}
				>
					{option.label}
				</OptionButton>
			))}
		</Track>
	);
};

export default PageSelector;
